import { CalendarOutlined } from "@ant-design/icons";
import { PATH_HOME } from "@configs";
import { selectMerchant } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { useNotify } from "@utils";
import { Button, Tabs } from "antd";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import { pumkinAPI } from "../../API/pumkin";
import { BackIcon } from "../icon/TopSpender/BackIcon";
import PopupDeviceDesc from "./PopupDeviceDesc";

const { TabPane } = Tabs;

export const ComponentMydevice = () => {
    const qrRef = useRef();
    const { success, error, warning } = useNotify();
    const history = useHistory();
    const [tab, setTab] = useState<string>("1");
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const { themes } = useSelector(selectMerchant);
    const listInnerRef = useRef<HTMLDivElement | null>(null);

    const [page, setPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [deviceList, setDeviceList] = useState<any[]>([]);
    const [dataClick, setDataClick] = useState<any>({});
    const themeColor = themes?.themeColor;

    function callback(items: any) {
        setTab(items);
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                UIStore.setState({ isLoading: true });
                setLoading(true);
                const getList = await pumkinAPI.getDeviceList(`?limit=10&page=${page}`);
                console.log("getList =>", getList.data);
                // settLeaderboardList(getList.data?.docs ? getList.data?.docs : []);
                setDeviceList((prevData) => [
                    ...prevData,
                    ...(getList.data?.docs ? getList.data?.docs : []),
                ]);
            } catch (err: any) {
                err.response?.data?.message
                    ? error(err.response?.data?.message)
                    : error(err.message);
            } finally {
                setLoading(false);
                UIStore.setState({ isLoading: false });
            }
        };

        fetchData();
    }, [page]);

    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10 && !loading) {
                if (page * 10 === deviceList?.length) {
                    setPage((prevPage) => prevPage + 1);
                }

                // This will be triggered after hitting the last element.
                // API call should be made here while implementing pagination.
            }
        }
    };

    return (
        <StyledContainer color={themes?.themeColor!}>
            <div className="container">
                <div className="backIcon" onClick={() => history.push(PATH_HOME)}>
                    <BackIcon color={"#FFF"} />
                    <h2>อุปกรณ์ของฉัน</h2>
                    <p> </p>
                </div>
                <div className="content">
                    <Tabs defaultActiveKey="1" activeKey={tab} onChange={callback}>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "1" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    ทั้งหมด
                                </span>
                            }
                            key="1"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status !== "PENDING" && item.status !== "REJECT") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : item.status === "APPROVE"
                                                            ? "อนุมัติ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "2" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    รับสินค้าเข้าระบบ
                                </span>
                            }
                            key="2"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status === "ACCEPT") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "3" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    ตรวจสอบ
                                </span>
                            }
                            key="3"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status === "VERIFY") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "4" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    รอเบิกอะไหล่
                                </span>
                            }
                            key="4"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status === "WAITING") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "5" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    กำลังซ่อม
                                </span>
                            }
                            key="5"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status === "FIXING") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "6" ? themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    งานซ่อมเสร็จ
                                </span>
                            }
                            key="6"
                        >
                            <div onScroll={onScroll} ref={listInnerRef} className="contentRow">
                                {deviceList?.map((item: any, index: number) => {
                                    if (item.status === "FIXDONE") {
                                        return (
                                            <div
                                                className="listColumn"
                                                key={index}
                                                onClick={() => setDataClick(item)}
                                            >
                                                <div>
                                                    <img src={item.productImage} />
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <div className="title">{item.productName}</div>
                                                    <div className="desc">
                                                        รุ่น {item.productModel}
                                                    </div>
                                                    <div className="desc">
                                                        ซีเรียล : {item.serialNumber}
                                                    </div>
                                                    <div className="expire">
                                                        <span>
                                                            <CalendarOutlined />
                                                        </span>{" "}
                                                        หมดเขตประกัน :{" "}
                                                        {format(
                                                            new Date(item?.expireWarrantyDate),
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>
                                                    <div className="status">
                                                        {item.status === "ACCEPT"
                                                            ? "รับสินค้าเข้าระบบ"
                                                            : item.status === "VERIFY"
                                                            ? "ตรวจสอบ"
                                                            : item.status === "WAITING"
                                                            ? "รอเบิกอะไหล่"
                                                            : item.status === "FIXING"
                                                            ? "กำลังซ่อม"
                                                            : item.status === "FIXDONE"
                                                            ? "งานซ่อมเสร็จ"
                                                            : ""}
                                                    </div>
                                                    <div className="bottom-line">
                                                        <div className="desc">
                                                            ไอดีการรับประกัน :{" "}
                                                            <span className="expire">
                                                                {item?.warrantyId}
                                                                {"   "}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                className="btn-desc"
                                                                onClick={() => setShowPopup(true)}
                                                            >
                                                                รายละเอียด
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            {isShowPopup && (
                <PopupDeviceDesc onClose={() => setShowPopup(false)} data={dataClick} />
            )}
        </StyledContainer>
    );
};
const StyledContainer = styled.div<{ color: string }>`
    height: 100dvh;
    background-color: ${(p) => p.color};
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 300;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: ${(p) => p.color};
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 5px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }
    .container {
        .backIcon {
            display: flex;
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
            align-items: center;
            justify-content: space-between;
            width: 80%;
        }
        h2 {
            color: #fff;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }

    .content {
        width: 100%;
        height: 90dvh;
        /* background-color: white; */
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 9px 16px 0px 16px;
        .ant-tabs-nav {
            .ant-tabs-tab {
                padding: 0;
                margin: 0px 10px 10px 0px !important;
                width: fit-content;
                span {
                    font-size: 13px;
                    font-weight: 600;
                }
            }
        }
        h1 {
            color: #000;
            font-size: 18px;
            line-height: 21px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        p {
            color: #9b9b9b;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 16px;
        }
        small {
            color: #525257;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            display: block;
        }
        .listTitle {
            color: ${(p) => p.color};
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        .readMoreButton {
            text-decoration: underline;
            background: none;
            border: none;
            cursor: pointer;
            color: ${(p) => p.color};
            font-size: inherit;
        }
        .contentRow {
            display: flex;
            flex-direction: column;
            gap: 6px;
            position: relative;
            overflow: auto;
            height: 80dvh;
            padding-bottom: 20px;
        }
        .listColumn {
            display: flex;
            padding: 14px 0px;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 12px;
            align-self: stretch;
            border-bottom: 1px solid #f0f0f0;
            width: 100%;
            max-width: 480px;
            img {
                width: 100%;
                max-width: 128px;
                object-fit: cover;
            }
            .title {
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .desc {
                color: #000;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .expire {
                color: #000;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }
            .status {
                display: flex;
                padding: 1px 8px 3px 8px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 30px;
                background: rgba(255, 128, 11, 0.12);
                color: #ff800b;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                width: 100px;
            }
            .bottom-line {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            }
            .btn-desc {
                display: flex;
                padding: 6px 13px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                background: #231f20;
                color: #fff;
                text-align: center;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                width: fit-content;
            }
        }
        .bottomContent {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 10dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: ${(p) => p.color};
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
        }

        textScan {
            color: var(--Text-6, #fff);
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        .bottomContentAndRank {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 15dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: var(--Primary-1, #336c51);
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
            .listItemsRow {
                padding: 0px 20px;
                width: 100%;
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .blueText {
                    color: ${(p) => p.color};
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: inherit;
                    text-align: right;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
                .textrank {
                    color: #fff;
                    font-size: 8px;
                }
            }
        }
        .contentCollect {
            align-items: center;
            overflow: auto;
            height: 55dvh;
            h2 {
                color: var(--Text-1, #000);
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin-top: 10px;
                margin-bottom: 10px;
            }
            h1 {
                color: var(--Error, #e53223);
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin-top: 10px;
                margin-bottom: 10px;
                gap: 10px;
                display: flex;
                justify-content: center;
            }
            img {
                width: 100%;
                border-radius: 14px;
            }
            .contentProgress {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                height: 70px;
                width: 100%;
                border-radius: 12px;
                background-repeat: no-repeat;
                background-image: url(../../images/bg-box-reward.png);
                background-size: cover;
                background-position: center;
                .numProgress {
                    color: var(--Text-4, #336c51);
                    text-align: center;
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
                .textProgress {
                    color: var(--Text-4, #336c51);
                    text-align: center;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
            }
            .wrapper-content-point {
                position: relative;
                .img-contentpoint-top {
                    position: absolute;
                    top: -25px;
                    z-index: 1;
                    left: calc(50% + 50px);
                    transform: translateX(-50%);
                    img {
                        width: 65px;
                    }
                }
                .img-contentpoint-bottom {
                    position: absolute;
                    bottom: -45px;
                    left: 50%;
                    z-index: 1;
                    transform: translateX(-50%);
                    img {
                        width: 260px;
                    }
                }
                .contentPoint {
                    position: relative;
                    display: flex;
                    width: 100%;
                    height: 115px;
                    padding: 10px 0px;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 1px;
                    flex-shrink: 0;
                    border-radius: 12px;
                    border: 1px solid rgba(242, 202, 60, 0.54);
                    // background: linear-gradient(0deg, rgba(242, 202, 60, 0.20) 0%, rgba(242, 202, 60, 0.20) 100%), #FFF;
                    box-shadow: 0px 4px 20px 0px rgba(242, 202, 60, 0.2);
                    background-image: url(../../images/bg-bonus.png);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    h1 {
                        color: var(--Text-1, #000);
                        text-align: center;
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                    }
                    p {
                        color: var(--Text-1, #000);
                        text-align: center;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                    }
                }
            }
        }
    }
`;
